<app-guest>
  <div class="card-body text-center">
    <i class="bi bi-check-circle-fill text-success display-4"></i>
    <h1 class="fw-bold fs-5 mt-3">Your request has been received</h1>
    <p class="text-muted">An account manager will contact you shortly.</p>
    <a routerLink="/login" class="btn btn-primary fw-bold p-lg-3">Return to login</a>
  </div>
</app-guest>
